import { createContext, useContext, useState } from 'react';
import { UserSettings, UserSettingsContextType, ContextProviderProps } from '../utils/types';

// The passcode gate's state. The cart and wishlist contexts that used to live here went with
// the cart: the Silvr surface sends shoppers to the retailer instead of checking out locally.
const UserSettingsContext = createContext<UserSettingsContextType | undefined>(undefined);

export const UserSettingsProvider = ({ children }: ContextProviderProps) => {
  const [userSettings, setUserSettings] = useState<UserSettings | null>(null);

  return <UserSettingsContext.Provider value={{ userSettings, setUserSettings }}>{children}</UserSettingsContext.Provider>;
};

export const useUserSettingsContext = () => {
  const context = useContext(UserSettingsContext);
  if (!context) {
    throw new Error('useUserSettingsContext must be used within a UserSettingsProvider');
  }
  return context;
};
